import React, { FC, useContext } from 'react';

import { Grid, Paper } from '@material-ui/core';

import { GlobalContext } from '../../../../store';
import { IPlayer } from '../../../../store/user/store';

import AddPlayersCard from '../../../../components/AddPlayersCard';
import PlayerLookup from '../../../../components/PlayerLookup/PlayerLookup';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';

const ClubRosterSection: FC = () => {
  const { adminMemberships } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  const players: IPlayer[] = adminMemberships.memberships.map(membership => membership.user);

  return (
    <div className="club-roster-section admin-layout">
      <div className="shadowed-headline">
        <h2>Club Roster</h2>
      </div>

      <Grid className="grid" container={true} spacing={2}>
        <Grid className="grid-item add-players-card-container" item={true} xs={12} md={6}>
          <AddPlayersCard
            buttonText={'Add Players'}
            className={'add-emails-full'}
            descriptionText={
              'Add players to the club by inputting their email below. If you want to add more ' +
              'than one email, just separate each email by a comma. '
            }
            headerText={'ADD PLAYERS TO THE CLUB'}
          />
        </Grid>

        <Grid className="grid-item player-lookup-container" item={true} xs={12} md={6}>
          <Paper className="paper no-min-height" elevation={1}>
            <h3>Find a player</h3>

            {clubId && (
              <PlayerLookup
                clubId={clubId}
                containerStyle={{ marginTop: '0', marginBottom: '15px' }}
                defaultHidden={true}
                listHeight={500}
                outlinedInput={true}
                players={players}
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default ClubRosterSection;
